"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const FormBase = (_a) => {
    var { onSubmit } = _a, rest = __rest(_a, ["onSubmit"]);
    const handleSubmit = (event) => {
        event.preventDefault();
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
    };
    return (0, jsx_runtime_1.jsx)("form", Object.assign({ onSubmit: handleSubmit }, rest));
};
/**
 * A basic form element wrapper that handles form submission in an expected and normalized way.
 * */
exports.BaseForm = (0, styled_components_1.default)(FormBase).attrs((p) => ({
    className: "form-normalized-outer-spacing",
})) `
  &.form-normalized-outer-spacing {
    margin-bottom: 0;
  }
`;
